// extracted by mini-css-extract-plugin
module.exports = {"a-footer_push-up":"footer_a-footer_push-up__QspIg","a-footer_slime":"footer_a-footer_slime__mSj9O"};